export default __webpack_public_path__ + "static/media/03e_fold-17.3d719a86.mp4";